import React, { FC } from 'react';
import { QueryObserverResult } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { UpcomingInstanceItemType } from 'components/admin/orders/recurring-orders/components/UpcomingInstanceItem';
import styles from 'components/admin/orders/recurring-orders/individualRecurringOrder.module.scss';
import Modal from 'components/common/Modal';
import { Button, ButtonVariant } from 'components/common/buttons/Button';
import { createRecurringOrderByInstanceWeek } from 'api/admin/orders/createRecurringOrderByInstanceWeek';

export const OrderCreationModal: FC<{
  recurringOrderId: number | string;
  item: UpcomingInstanceItemType;
  onClose: () => void;
  refetchRecurringOrderDetails: () => Promise<QueryObserverResult>;
}> = ({ recurringOrderId, item, onClose, refetchRecurringOrderDetails }) => {
  const onOrderCreate = async () => {
    try {
      await createRecurringOrderByInstanceWeek({
        recurringOrderId,
        instanceWeek: item.data.isoInstanceWeek,
      });
      await refetchRecurringOrderDetails();
      toast.success('Order created successfully');
      onClose();
    } catch (error) {
      toast.error(`Error: ${error?.response?.data?.error}`);
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className={styles.orderCreationModal}>
        <h2>Do you want to create an order with the following configuration?</h2>
        <div className={styles.configuration}>
          <p>
            <span>Pickup window:</span> {item.data.pickupWindow}
          </p>
          <p>
            <span>Return window:</span> {item.data.returnWindow}
          </p>
        </div>
        <div className={styles.controls}>
          <Button onClick={onClose} type={ButtonVariant.OUTLINED}>
            No
          </Button>
          <Button onClick={onOrderCreate} type={ButtonVariant.CONTAINED}>
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};
